import gev from '../images/GEV.png';
import igbc from '../images/IGBC.jpg';
import nselogo from '../images/NSE-logo.png'
import ksos from "../images/Kotak-School.jpeg"
import IITB from "../images/gush-iitb.jpeg"
import NT from "../images/national_technologies.jpeg"

export const partnerLogos2026 = [
    { href: 'https://ecovillage.org.in/', img: gev, alt: 'GEV-Logo', className: 'gev' },
    { href: 'https://kss.iitk.ac.in/', img: ksos, alt: 'KSoS-Logo', className: 'inst-logo KSoS' },
    { href: 'https://gesh.iitb.ac.in/', img: IITB, alt: 'IITB-Logo', className: 'gesh' },
    { href: 'https://igbc.in/', img: igbc, alt: 'IGBC-Logo', className: 'igbc' },
    { href: 'https://www.nitw.ac.in/', img: NT, alt: 'nt-Logo', className: 'nt' },
];